import {Component, OnInit, ViewChild} from '@angular/core';
import {Funcionalidad} from '../../_models/funcionalidad';
import {Table} from 'primeng/table';
import {RutasFuncionalidades} from '../../_enums/enum';
import {AutenticacionService} from '../../_services/autenticacion.service';
import {NavService} from '../../_services/_nav.service';
import {Router} from '@angular/router';
import {ConvenioPlanCargo} from '../../_models/convenio-plan-cargo';
import {forkJoin} from 'rxjs';
import {ConveniosConceptosService} from '../../_services/convenios-conceptos.service';

@Component({
  selector: 'app-convenios-plan-cargo-listado',
  templateUrl: './convenios-plan-cargo-listado.component.html',
  styleUrls: ['./convenios-plan-cargo-listado.component.css']
})
export class ConveniosPlanCargoListadoComponent implements OnInit {

  cargando = true;
  funcionalidad: Funcionalidad = new Funcionalidad();
  convenioPlanCargo: ConvenioPlanCargo[] = [];
  busqueda: string;
  columnas: any[];
  filtroBusqueda = [
    'codigo',
    'nombre'
  ];
  @ViewChild("dt", { static: true }) tabla: Table;
  carInformacion = true;
  pagina: string;
  regPorPagina = 10;
  editar = false;
  agregar = false;

  constructor(  private authService: AutenticacionService,
                private navService: NavService,
                private router: Router,
                private convenioPlanCargoService: ConveniosConceptosService,


  ) { }

  ngOnInit() {
    const mn = this.authService.obtenerFuncionalidades().find((x) => x.ruta === RutasFuncionalidades.CONVENIOPLANCARGO);
    if (mn) {
      this.funcionalidad = mn;
    }
    this.validarPermisos();
    this.cargarIncial();
  }

  validarPermisos() {
    if (this.funcionalidad && this.funcionalidad.editar) {
      this.editar = true;
    } else {
      this.navService.setMesage(0, {
        severity: 'info',
        summary: this.navService.buscarMensaje('LBL_INFORMACION'),
        detail: this.navService.buscarMensaje('CONVENIOSPLANESCARGOS.MSG_NOEDITAR'),
      });
    }

    if (this.funcionalidad && this.funcionalidad.agregar) {
      this.agregar = true;
    } else {
      this.navService.setMesage(0, {
        severity: 'info',
        summary: this.navService.buscarMensaje('LBL_INFORMACION'),
        detail: this.navService.buscarMensaje('CONVENIOSPLANESCARGOS.MSG_SINPERMISOS'),
      });
    }
  }

  cargarColumnas() {
    this.columnas = [
      {field: 'planCargosProducto', header: this.navService.buscarMensaje('CONVENIOSPLANESCARGOS.LBL_CODIGOCONVENIO'), sort: true},
      {field: 'planCargosGarantia', header: this.navService.buscarMensaje('CONVENIOSPLANESCARGOS.LBL_NOMCONVENIO'), sort: true},
      {field: 'codigoEnviar', header: this.navService.buscarMensaje('CONVENIOSPLANESCARGOS.LBL_DESCRIPCION'), sort: true},
      {field: 'indicadorHabilitado', header: this.navService.buscarMensaje('CONVENIOSPLANESCARGOS.LBL_INDICADORHABILITADO'), sort: true},
      {field: 'acciones', header: this.navService.buscarMensaje('LBL_ACCIONES'), sort: false},
    ];
    this.carInformacion = false;
    this.cargando = false;

    this.busqueda = this.navService.getSearch(
      "convenios-planes-cargos.component"
    );
  }

  agregarConvenio() {
    this.router.navigate(['apl/convenio-plan-cargo/agregar']);
  }

  editarConvenio(convenioPlanCargo: ConvenioPlanCargo) {
    this.router.navigate(['apl/convenio-plan-cargo/actualizar/' + convenioPlanCargo.idConvenioConcepto]);
  }

  verDetallleConvenio(convenioPlanCargo: ConvenioPlanCargo) {
    this.router.navigate(['apl/convenio-plan-cargo/detalle/' + convenioPlanCargo.idConvenioConcepto]);
  }

  cargarIncial() {
    this.cargarColumnas();
    forkJoin(this.convenioPlanCargoService.listado()).subscribe(([convenioPlanCargo]) => {
      this.convenioPlanCargo = convenioPlanCargo;
    });
  }

  setBusqueda() {
    this.navService.setSearch(
      "convenios-planes-cargos.component",
      this.busqueda
    );
  }
}
